<template>
  <div>
    <div>
      <el-form :inline="true">
        <el-form-item label="群码名称：">
          <el-input
            v-model="searchParams.qrName"
            size="mini"
            clearable
            @change="getList"
          />
        </el-form-item>
        <el-form-item label="使用场景：">
          <el-input
            v-model="searchParams.sceneName"
            size="mini"
            clearable
            @change="getList"
          />
        </el-form-item>
        <el-form-item label="创建时间：">
          <el-date-picker
            v-model="date"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            size="mini"
            @change="selectBindStatus"
          />
        </el-form-item>
        <el-form-item label="创建人：">
          <el-input
            v-model="searchParams.creatorName"
            size="mini"
            clearable
            @change="getList"
          />
        </el-form-item>
        <el-form-item label="使用员工：">
          <el-input
            v-model="searchParams.userName"
            size="mini"
            clearable
            @change="getList"
          />
        </el-form-item>
        <el-form-item label="拉群方式：">
          <el-select
            v-model="searchParams.qrType"
            placeholder="请选择"
            size="mini"
            @change="getList"
            clearable
          >
            <el-option label="通过加好友进群" value="0"></el-option>
            <el-option label="直接进群" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态：">
          <el-select
            v-model="searchParams.qrStatus"
            placeholder="请选择"
            size="mini"
            @change="getList"
            clearable
          >
            <el-option label="启用" value="1"></el-option>
            <el-option label="停用" value="2"></el-option>
            <el-option label="失效" value="3"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      size="small"
      :data="tableData"
      fit
      highlight-current-row
      align="center"
      :header-cell-style="{ background: '#eef1f6' }"
      height="650"
      ref="cusChatTable"
    >
      <el-table-column
        prop="qrName"
        label="活码名称"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column prop="sceneName" label="使用场景" align="center">
      </el-table-column>
      <el-table-column  label="状态" align="center">
        <template slot-scope="scope">
          <span style="color:#81bcfd" v-if="scope.row.qrStatus == 1">可用</span>
          <span style="color:#fdd554" v-if="scope.row.qrStatus == 2">停用</span>
          <span style="color:#ff6464" v-if="scope.row.qrStatus == 3">失效</span>
        </template>
      </el-table-column>
      <el-table-column prop="chatGroupNum" label="使用群聊数" align="center">
      </el-table-column>
      <el-table-column prop="chatGroupMemberTotalNum" label="扫码人数" align="center">
      </el-table-column>
      <el-table-column prop="joinChatGroupTotalMemberNum" label="进群人数" align="center">
      </el-table-column>
      <el-table-column label="退群人数" align="center" prop="exitChatGroupTotalMemberNum">
      </el-table-column>
      <el-table-column prop="operation" label="操作" align="center">
        <template slot-scope="scope">
          <el-link @click="checkDetail(scope.row)">查看明细</el-link>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-bind:childMsg="pageparm"
      :pageSizes="pageSizes"
      @callBack="callBack"
    ></Pagination>
    <el-dialog
      style="height: 600px"
      title="活码明细"
      :visible.sync="tagVisible"
      :close-on-click-modal="false"
      width="30%"
      close-on-press-escape
      v-if="tagVisible"
    >
      <div>活码名称: {{ qrName }}</div>
      <div v-for="i in checkDetailList">
        <div class="title">群聊：{{ i.groupName }}</div>
        <div class="list">
          <div class="item">进群人数：{{ i.joinChatGroupTotalMemberNum !=null || i.joinChatGroupTotalMemberNum != undefined ? i.joinChatGroupTotalMemberNum : 0 }}</div>
          <div class="item">退群人数：{{ i.exitChatGroupTotalMemberNum !=null || i.exitChatGroupTotalMemberNum != undefined ? i.exitChatGroupTotalMemberNum : 0 }}</div>
          <div class="item">当前群人数：{{ i.chatGroupMemberTotalNum !=null || i.chatGroupMemberTotalNum != undefined ? i.chatGroupMemberTotalNum : 0 }}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  // getList,
  getTagList,
  getGroupMessage,
  addTagItems,
  deleteGroupTags,
} from "../../api/group/index.js";
import {
  getList,
  getGroupCodeDetail
} from "@/api/group/code.js";
import groupChatView from "./components/groupChatView";
import Tag from "./tag.vue";
import dayjs from "dayjs";
export default {
  name: "CusChatSupervise",
  components: {
    groupChatView,
    Tag,
  },
  data() {
    return {
      tableData: [],
      tableHeight: 500,
      pageparm: {
        pageNum: 1,
        pageSize: 20,
        total: 10,
      },
      searchParams: {
        current: 1,
        size: 20,
        qrName: "",
        sceneName: "",
        startTime: "",
        endTime: "",
        creatorName: "",
        userName: "",
        qrType: "",
        qrStatus: "",
      },
      pageSizes: [20, 50, 100, 200, 500], //分页条数
      date: null,
      tagVisible: false,
      checkDetailList: [],
      qrName: ''
    };
  },
  created() {
    this.getList(this.searchParams);
  },
  methods: {
    checkDetail(row){
      getGroupCodeDetail(localStorage.getItem("Authorization"), row.qrId ).then(res=>{
        console.log("res", res);
        if(res.error.code == 200){
          this.checkDetailList = res.data.groupQrDetail
          this.qrName = res.data.qrName
         this.tagVisible = true
        }
      })
      
    },
    selectBindStatus() {
      this.searchParams.pageNum = 1;
      if (this.date != null) {
        this.searchParams.startTime = dayjs(this.date[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.searchParams.endTime =
          dayjs(this.date[1]).format("YYYY-MM-DD") + " " + "23:59:59";
      } else {
        this.searchParams.startTime = "";
        this.searchParams.endTime = "";
      }
      this.getList(this.searchParams);
    },
    selectTime() {
      this.searchParams.pageNum = 1;
      this.getList(this.searchParams);
    },
    onInputBlur() {
      this.searchParams.pageNum = 1;
      this.getList(this.searchParams);
    },
    // 获取群活码
    getList() {
      getList(localStorage.getItem("Authorization"), this.searchParams).then(
        (res) => {
          // console.log("res");
          // console.log(res);
          if (res.error.code == 200) {
            if (res.data.rows.length > 0) {
              this.tableData = res.data.rows;
              this.pageparm.total = res.data.total;
              this.pageparm.pageNum = this.searchParams.current;
              this.pageparm.pageSize = this.searchParams.size;
              // this.total = res.data.total
            } else {
              this.tableData = [];
            }
          }
        }
      );
    },
    // getList(parameter) {
    //   getList(parameter, localStorage.getItem("Authorization")).then((res) => {
    //     if (res.error.code == 200) {
    //       if (res.data.rows.length > 0) {
    //         this.tableData = res.data.rows;
    //         this.pageparm.total = res.data.count;
    //         this.pageparm.pageNum = this.searchParams.pageNum;
    //         this.pageparm.pageSize = this.searchParams.pageSize;
    //       } else {
    //         this.tableData = [];
    //       }
    //     }
    //   });
    // },
    callBack(parm) {
      this.searchParams.pageNum = parm.currentPage;
      this.searchParams.pageSize = parm.pageSize;
      this.getList(this.searchParams);
    },
  },
}; 
</script>
<style lang="scss" scoped>
.list {
  display: flex;
  margin-top: 8px;
  .item {
    margin-right: 40px;
  }
}
.title {
  margin-top: 10px;
  font-weight: bold;
}
</style>
